import {ReactElement} from "react";
import {MenuFormat, PageBreakItem} from "../MenuDocumentModel";
import {EditorItem} from "../editorUtils";
import {FormattedMessage} from "react-intl";

export interface PageBreakPreviewItemProps {
    format: MenuFormat
    pageBreak: EditorItem<PageBreakItem>
}

export function PageBreakPreviewItem(props: PageBreakPreviewItemProps): ReactElement {
    return (
        <div className="flex-auto border border-dotted border-[gray-1]-1 border-2 text-center">
            <FormattedMessage id="editor.pageBreak"/>
        </div>
    );
}
